import { render } from "./ConfigSection.vue?vue&type=template&id=46c235b2&scoped=true"
import script from "./ConfigSection.vue?vue&type=script&lang=js"
export * from "./ConfigSection.vue?vue&type=script&lang=js"

import "./ConfigSection.vue?vue&type=style&index=0&id=46c235b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c235b2"]])

export default __exports__